/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = {
  addToCart: () => void;
};

export const AddToCartButtonV2: FcWithoutChildren<Props> = (props) => {
  const { addToCart } = props;

  return (
    <button css={rootStyle} onClick={addToCart}>
      {/* TODO: 多言語対応 */}
      カート追加
    </button>
  );
};

const rootStyle = css`
  background-color: black;
  color: white;
`;
